<template>
  <div class="relative h-full">
    <div v-if="role !== 'TALENT GLOBAL'">
      <BAlert
        :show="totalCard >= maxCard && isUnlimitedCard"
        variant="success"
        class="p-1"
      >
        <div class="flex flex-row items-center justify-between gap-2">
          <div class="flex items-start gap-3 mb-[10px]">
            <img
              class="h-[20px]"
              src="https://storage.googleapis.com/komerce/assets/icons/Checklist-fill.svg"
              alt="check-list"
            >
            <div>
              <h4 class="text-[#626262] font-semibold text-[16px] m-0">
                Berhasil mendapatkan kuota kartu unlimited!
              </h4>
              <div class="text-[#626262] text-[14px] mt-[12px]">
                Terus gunakan kartumu dan lakukan spending sebanyak-banyaknya
              </div>
            </div>
          </div>
          <div class="w-[20px]">
            &nbsp;
          </div>
        </div>
      </BAlert>
      <BAlert
        v-if="isCheckKyc"
        show
        :variant="[3, 4].includes(profile.verification_ktp_status) ? 'danger' : 'warning'"
        class="p-2"
      >
        <div class="flex flex-row items-center justify-between gap-2">
          <div>
            <div class="flex items-center gap-3 mb-[10px]">
              <img
                :src="[3, 4].includes(profile.verification_ktp_status) ? 'https://storage.googleapis.com/komerce/assets/svg/info-circle-red.svg' : 'https://storage.googleapis.com/komerce/assets/svg/warning-Info-circle.svg'"
                alt="Komerce"
              >
              <h4 class="text-black font-semibold m-0">
                {{ titleCheckKyc }}
              </h4>
            </div>
            <BCardText class="text-[#333333]">
              {{ messageCheckKyc }}
            </BCardText>
          </div>
          <BButton
            v-if="
              profile.verification_ktp_status === 0 ||
                profile.verification_ktp_status === 3 ||
                profile.verification_ktp_status === 4
            "
            size="sm"
            :variant="profile.verification_ktp_status === 3 || profile.verification_ktp_status === 4 ? 'outline-danger' : 'outline-warning'"
            @click="$router.push('/verification-ktp')"
          >
            {{ buttonKycBanner }}
          </BButton>
        </div>
      </BAlert>
      <BAlert
        v-if="warningMessage !== null"
        show
        variant="warning"
        class="p-2"
        dismissible
      >
        <h4 class="text-black font-semibold">
          Informasi Pembuatan Kartu
        </h4>
        <template slot="dismiss">
          <img
            src="https://storage.googleapis.com/komerce/assets/icons/close-circle.svg"
            alt="Komerce"
            width="20"
            class="cursor-pointer"
          >
        </template>
        <BCardText class="text-[#333333]">
          {{ warningMessage }}
        </BCardText>
      </BAlert>
      <BAlert
        v-if="isBannerLowScore.show"
        show
        variant="danger"
        class="p-2 border-danger"
        :dismissible="isBannerLowScore.dismissible"
      >
        <div class="flex items-start gap-3 mb-[10px]">
          <img
            class="h-[20px]"
            src="https://storage.googleapis.com/komerce/assets/svg/info-circle-red.svg"
            alt="info-circle"
          >

          <div>
            <h4 class="text-black font-semibold">
              {{ isBannerLowScore.title }}
            </h4>
            <template slot="dismiss">
              <img
                src="https://storage.googleapis.com/komerce/assets/icons/close-circle.svg"
                alt="Komerce"
                width="20"
                class="cursor-pointer"
              >
            </template>
            <div
              class="text-[#333333] mb-[5px]"
              v-html="isBannerLowScore.desc"
            />
            <a
              v-if="isBannerLowScore.showLinkHelpdesk"
              :href="helpdesk"
              target="_blank"
              class="text-[#08A0F7] hover:text-[#08A0F7]"
            >
              Panduan Komcards Score
            </a>
          </div>
        </div>

      </BAlert>
      <BAlert
        v-if="isBannerScoring.show"
        show
        variant="warning"
        class="p-2 border-warning"
        :dismissible="isBannerScoring.dismissible"
      >
        <div class="flex items-start gap-3 mb-[10px]">
          <img
            class="h-[20px]"
            src="https://storage.googleapis.com/komerce/assets/svg/warning-Info-circle.svg"
            alt="info-circle"
          >

          <div>
            <h4 class="text-black font-semibold">
              {{ isBannerScoring.title }}
            </h4>
            <template slot="dismiss">
              <img
                src="https://storage.googleapis.com/komerce/assets/icons/close-circle.svg"
                alt="Komerce"
                width="20"
                class="cursor-pointer"
              >
            </template>
            <div
              class="text-[#333333] mb-[5px]"
              v-html="isBannerScoring.desc"
            />
          </div>
        </div>

      </BAlert>
    </div>
    <BCard>
      <BRow class="items-center justify-between pl-[15px] pr-[15px]">
        <div class="flex gap-[12px] items-center">
          <div class="text-black font-semibold m-0 text-2xl">
            {{ role !== 'TALENT GLOBAL' ? 'Kartu' : 'Total kartu yang diberi akses' }}
          </div>
          <div class="text-[16px] flex items-center border-[1px] border-[#E2E2E2] rounded-[8px] px-[8px] py-[4px] py px-[12px] py-[8px]">
            <div
              v-if="role !== 'TALENT GLOBAL'"
              class="flex items-center gap-1"
            >
              <span class="text-[#34A770]">{{ filtered_total }}/</span>
              <span v-if="typeControl === 'komcard_score' && (totalCard >= maxCard && isUnlimitedCard)">
                <img
                  alt="infinity card"
                  class="h-[14px]"
                  src="https://storage.googleapis.com/komerce/assets/elements/badge-infinite.png"
                >
              </span>
              <span v-else>
                {{ maxCard }}
              </span>
            </div>
            <span
              v-else
              class="text-[#34A770]"
            >
              {{ totalCard }}
            </span>
          </div>
        </div>
        <div class="flex gap-2">
          <!-- Notification Dropdown -->
          <div
            v-if="role !== 'TALENT GLOBAL'"
            ref="dropdownNotification"
            class="komcard-notif-wrapper"
          >
            <button
              type="button"
              class="btn-notif-trigger"
              :class="{ 'is-active': isDropdownOpen }"
              @click="toggleDropdownNotification"
            >
              <img
                src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/setting-2.svg"
                alt="Komerce"
                class="notif-trigger-icon"
              >
              <span class="notif-trigger-text">
                Notifikasi ({{ activeNotificationCount }})
              </span>
              <span
                class="notif-status-dot notif-trigger-dot"
                :class="isAnyNotificationActive ? 'status-active' : 'status-inactive'"
              />
            </button>

            <transition name="notif-dropdown">
              <div
                v-if="isDropdownOpen"
                class="komcard-notif-menu"
              >
                <div
                  class="notif-menu-item"
                  @click="handleDeclineNotification"
                >
                  <span class="notif-item-title">Decline Notifikasi</span>
                  <div class="notif-item-meta">
                    <span
                      class="notif-status-dot"
                      :class="(notificationStatus && (notificationStatus.decline_notification === 'active' || notificationStatus.decline === true)) ? 'status-active' : 'status-inactive'"
                    />
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                      class="notif-item-chevron"
                    />
                  </div>
                </div>

                <div
                  class="notif-menu-item"
                  @click="handleTransactionNotification"
                >
                  <span class="notif-item-title">Notifikasi Transaksi</span>
                  <div class="notif-item-meta">
                    <span
                      class="notif-status-dot"
                      :class="(notificationStatus && (notificationStatus.transaction_notification === 'active' || notificationStatus.transaction === true)) ? 'status-active' : 'status-inactive'"
                    />
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                      class="notif-item-chevron"
                    />
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <BButton
            v-if="role !== 'TALENT GLOBAL'"
            size="sm"
            :variant="isAddCardDisabled ? 'secondary' : 'primary'"
            style="display: flex; align-items: center; justify-content: space-between; padding: 5px 10px;"
            :disabled="loading.pin || loading.balance || isAddCardDisabled"
            @click="checkPin('button-add')"
          >
            <img
              src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/card-add.svg"
              alt="Komerce"
              width="20"
            >
            <div class="d-none d-md-block font-semibold ml-[5px]">
              Tambah Kartu
            </div>
            <BSpinner
              v-if="loading.pin"
              variant="light"
              small
              class="ml-1"
            />
          </BButton>
        </div>
      </BRow>

      <!-- ketika kurang dari x dan active maka grid-cols-1 -->
      <div
        :class="[
          isActiveGamification
            ? 'grid-content-speding-2'
            : 'grid-content-speding-1',
          !isVerticalMenuCollapsed ? 'grid-content-speding-force' : '',
        ]"
        class="gap-[16px] mt-2"
      >
        <div class="mb-[5px]">
          <HealthAccount
            class="h-full"
            :score="score"
          />
        </div>
        <div class="mb-[5px]">
          <SpendingCategoryVue class="h-full" />
        </div>
        <div
          v-if="role !== 'TALENT GLOBAL'"
          class="mb-[5px]"
        >
          <Gamification
            v-if="isActiveGamification"
            :data-gamification="dataGamification"
            :max-spending-gamification="maxSpendingGamification"
            :leveling-gamification="levelingGamification"
            :spending-gamification="spendingGamification"
            :render-banner="renderBannerGamification"
            :render-progress="renderProgressGamification"
            @claim-gamification="handleClaimGamification"
          />
        </div>
      </div>

      <div
        class="flex justify-between items-end md:items-center mt-[16px]  gap-[10px] mb-[15px] md:mb-0"
      >
        <div class="flex items-end gap-[10px]">
          <div
            class="mt-[12px] w-[300px] sm:flex gap-[10px] sm:items-center w-full sm:w-auto"
          >
            <div class="flex gap-[2px] items-center relative">
              <img
                class="absolute h-[20px] ml-[7px]"
                src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/search-normal-1.svg"
                alt="search"
              >
              <BFormInput
                v-model="search_card"
                debounce="600"
                placeholder="Cari kartu komcards"
                class="pl-3 pr-2"
                style="height: 37px !important;"
                @keyup="handleEnterSearch"
              />
              <img
                v-if="search_card !== null"
                class="h-[12px] right-0 absolute mr-[10px] cursor-pointer"
                src="https://storage.googleapis.com/komerce/assets/LP-Komcard/close-circle.svg"
                alt="close"
                @click="resetSearch"
              >
            </div>
          </div>
          <VSelect
            ref="tapi"
            v-model="status_card"
            :options="optionStatus"
            :reduce="option => option.value"
            :clearable="false"
            class="w-[200px]  d-none d-md-block"
          />
        </div>
        <div
          class="flex border-[1px] d-none d-md-block rounded-[8px] overflow-hidden border-[#E2E2E2]"
        >
          <button
            :class="
              activeViewCard === 'grid'
                ? 'bg-[#F95031] text-white cursor-pointer'
                : 'bg-white text-[#F95031] cursor-auto'
            "
            class="p-[10px] border-r-[1px] border-[#E2E2E2]"
            @click="activeViewCard !== 'grid' && changeView('grid')"
          >
            <span class="k-category" />
          </button>
          <button
            :class="
              activeViewCard === 'list'
                ? 'bg-[#F95031] text-white cursor-pointer'
                : 'bg-white text-[#F95031] cursor-auto'
            "
            class="p-[10px]"
            @click="activeViewCard !== 'list' && changeView('list')"
          >
            <span class="k-menu" />
          </button>
        </div>
        <div class="d-md-none flex items-center gap-[6px]">
          <div class="h-[35px] w-[40px] relative">
            <button
              class="h-full w-full border-[1px] rounded-[8px] flex items-center justify-center  border-[#F95031] bg-white text-black cursor-pointer"
              @click="isActivePopover = !isActivePopover"
            >
              <span class="k-filter text-[#F95031]" />
            </button>
            <div
              v-show="isActivePopover"
              class="w-[200px] bg-white mt-[20px] overflow-hidden rounded-[8px] border-[1px] border-[#E2E2E2] z-[999] absolute right-1 top-6"
            >
              <div
                v-for="(option, index) in optionStatus"
                :key="index"
                :class="
                  status_card === option.value
                    ? 'bg-[#F8F8F8] text-[#c2c2c2]'
                    : 'text-[#828282]'
                "
                class="px-[12px] py-[8px]"
                @click="status_card = option.value"
              >
                {{ option.label }}
              </div>
            </div>
          </div>
          <div class="h-[35px] w-[40px]">
            <button
              class="h-full  w-full border-[1px] rounded-[8px] flex items-center justify-center border-[#E2E2E2] bg-white text-black cursor-pointer"
              @click="
                activeViewCard === 'grid'
                  ? changeView('list')
                  : changeView('grid')
              "
            >
              <span
                :class="activeViewCard !== 'grid' ? 'k-menu' : 'k-category'"
              />
            </button>
          </div>
        </div>
      </div>
      <!-- START : CARD LIST -->
      <div>
        <div
          v-if="
            dataCard.length === 0 && !loading.card && activeViewCard === 'grid'
          "
          body-class="card-dashed"
          class="mb-[10px]"
        >
          <BOverlay
            spinner-variant="primary"
            variant="light"
            blur="0"
            opacity=".5"
            rounded="sm"
          >
            <div
              class="flex flex-column mt-[12px]  justify-center items-center w-[290px]  sm:w-[350px] h-[250px] p-[20px] border-[1px] border-[#E2E2E2] rounded-[8px] border-dashed"
              :class="totalCard === 0 && 'hover:bg-[#F8F8F8] cursor-pointer'"
              @click="totalCard === 0 && checkPin('banner-empty-card')"
            >
              <img
                :src="
                  totalCard > 0
                    ? 'https://storage.googleapis.com/komerce/assets/komerce-icon/Ilustrasi-addcards.svg'
                    : 'https://storage.googleapis.com/komerce/assets/svg/empty-card.svg'
                "
                alt="Komerce"
                class="m-auto"
              >

              <div class="mt-2 text-[#626262]">
                <span v-if="totalCard > 0">Tidak Ada Kartu</span>
                <div
                  v-else
                  class="text-center"
                >
                  Kamu belum memiliki kartu. Yuk, buat kartu pertama kamu!
                </div>
              </div>
            </div>
          </BOverlay>
        </div>
      </div>
      <div class="sm:mt-[15px] lg:mt-0">
        <BOverlay
          v-if="activeViewCard === 'grid'"
          spinner-variant="primary"
          :show="loading.card"
        >
          <!-- START : GRID -->
          <VueSlickCarousel
            v-if="dataCard.length > 0"
            ref="carousel"
            :key="carouselKey"
            class="my-1"
            unslick
            :initial-slide="initialSlide"
            v-bind="settings"
            @afterChange="handleBeforeChange"
          >
            <MasterCard
              v-for="(data, key) in dataCard"
              :key="key"
              :data="data"
              :loading="loading.getBalanceMonit"
              @handleTopup="handleTopup"
              @handleDetail="handleDetail"
              @handleTransfer="handleTransfer"
            />
          </VueSlickCarousel>
          <!-- END : GRID -->
        </BOverlay>
        <BOverlay
          v-else
          spinner-variant="primary"
          :show="loading.card"
        >
          <!-- START : LIST -->
          <BTable
            :items="dataCard"
            :fields="renderListView(fieldsListView)"
            class="mt-[15px] table-card"
            show-empty
            :thead-class="windowWidth < 480 ? 'd-none' : ''"
            sticky-header="500px"
            @scroll.native="handleScroll"
          >
            <template #empty>
              <div
                v-if="
                  dataCard.length === 0 &&
                    totalCard === 0 &&
                    !loading.card &&
                    activeViewCard === 'list'
                "
                class="flex flex-column mt-[12px] bg-[#F8F8F8] justify-center items-center hover:bg-[#F8F8F8] cursor-pointer"
                @click="totalCard === 0 && checkPin('banner-empty-card')"
              >
                <img
                  src="https://storage.googleapis.com/komerce/assets/svg/empty-card.svg"
                  alt="Komerce"
                  class="m-auto"
                >
                <div class="mt-2 text-[#626262]">
                  <div class="text-center">
                    Kamu belum memiliki kartu. Yuk, buat kartu pertama kamu!
                  </div>
                </div>
              </div>
              <div
                v-else
                class="min-h-[50px] flex justify-center mt-[12px] w-full "
              >
                <div>
                  <img
                    src="https://storage.googleapis.com/komerce/assets/komerce-icon/Ilustrasi-addcards.svg"
                    alt="Komerce"
                    class="m-auto"
                  >
                  <div class="mt-1 mb-2 text-[#626262]">
                    <div class="text-center">
                      Tidak Ada Kartu
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template #cell(card_name)="data">
              <div class="text-[14px] gap-[6px] flex items-center justify-between">
                <div class="flex gap-1">
                  <span class="k-card text-[#C2C2C2] text-[20px]" />
                  <div>
                    <div class="flex gap-[4px]">
                      <span class="text-[#626262] text-nowrap">
                        {{ data.item.name }}
                      </span>
                      <div class="text-[#626262]">
                        {{
                          `***${
                            data.item.card_number
                              ? data.item.card_number.slice(-4)
                              : ''
                          }`
                        }}
                      </div>
                      <img
                        v-if="data.item.labels"
                        v-b-popover.hover.top="data.item.labels"
                        src="https://storage.googleapis.com/komerce/assets/svg/button-cards.svg"
                        alt="tag"
                        width="20"
                        class="cursor-pointer"
                      >
                    </div>
                    <div :class="windowWidth > 480 && 'd-none'">
                      <div v-if="data.item.balance">
                        {{ IDR(data.item.balance, 2, 2) }}
                      </div>
                      <div
                        v-if="data.item.balance === undefined"
                        class="color"
                      >
                        <span class="h-[10px] w-[100px]" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template #cell(level)="data">
              <div
                class="text-white rounded-full px-[10px] py-[1px] w-22 text-center"
                :class="[data.item.level === 'gold' ? 'bg-[#F6B732]' : data.item.level === 'bronze' ? 'bg-[#686868]' : 'bg-[#757F9A]']"
              >
                {{ data.item.level === 'gold' ? 'Gold' : data.item.level === 'bronze' ? 'Bronze' : 'Platinum' }}
              </div>
            </template>
            <template #cell(balance)="data">
              <div
                v-if="data.item.balance"
                :class="data.item.balance < 0 ? 'text-[#E31A1A]' : ''"
              >
                {{ IDR(data.item.balance, 2, 2) }}
              </div>
              <div
                v-if="data.item.balance === undefined"
                class="color"
              >
                <span class="h-[10px] w-[100px]" />
              </div>
            </template>
            <template #cell(team_members)="data">
              <div
                v-if="!isEmpty(data.item.team_members)"
                class="flex gap-[4px]"
              >
                <BAvatar
                  v-for="(value, idx) in data.item.team_members.slice(0, 5)"
                  :key="idx"
                  v-b-tooltip.hover
                  class="ml-[-10px] border-2 cursor-pointer"
                  :title="value"
                  :style="{ background: getAvatarData(value).background }"
                >
                  {{ getAvatarData(value).acronym }}
                </BAvatar>
                <BAvatar
                  v-if="data.item.team_members.length > 5"
                  v-b-tooltip.hover
                  class="ml-[-10px] border-2 cursor-pointer"
                  :title="data.item.team_members.slice(5).join(', ')"
                >
                  +{{ data.item.team_members.length - 5 }}
                </BAvatar>
              </div>
              <div v-else>
                -
              </div>
            </template>
            <template #cell(action)="data">
              <img
                v-if="data.item.balance < 0"
                :id="'popover-warning' + data.item.id"
                src="https://storage.googleapis.com/komerce/Komcards/warning-triangle.svg"
                alt="warning"
                width="20"
                class="cursor-pointer mr-1 mr-lg-0"
              >
              <BPopover
                v-if="data.item.balance < 0"
                triggers="hover"
                placement="top"
                :target="'popover-warning' + data.item.id"
                custom-class="popover-warning-balance"
              >
                <span>Saldo minus membatasi fitur kartu. Lakukan Top Up untuk memulihkan akses</span>
              </BPopover>
              <button
                :id="'popover-action' + data.item.id"
                class="p-[6px] rounded-[8px] bg-[#F8F8F8]"
                :class="windowWidth > 480 && 'd-none'"
                @click="
                  handleClickPopoverOnTable('popover-action' + data.item.id)
                "
              >
                <span class="k-more text-[#333333]" />
              </button>
              <BPopover
                triggers="click"
                placement="bottomleft"
                :target="'popover-action' + data.item.id"
              >
                <button
                  v-if="role !== 'TALENT GLOBAL'"
                  class="flex gap-1 items-center"
                  :class="data.item.level === 'gold'
                    ? 'cursor-not-allowed' :
                      renderActionList('topup', data.item.status)
                        ? 'text-[#333333] cursor-pointer hover:bg-[#FFECE9]'
                        : 'text-[#c2c2c2]'
                  "
                  @click="data.item.level !== 'gold'
                    && renderActionList('topup', data.item.status) &&handleTopup(data.item)"
                >
                  <span class="k-send-square text-[16px]" />
                  <span class="text-[14px]">Topup</span>
                </button>
                <button
                  class="flex gap-1 mt-[8px] items-center"
                  :class="
                    renderActionList('transfer', data.item.status) && data.item.balance >= 0
                      ? 'text-[#333333] cursor-pointer hover:bg-[#FFECE9]'
                      : 'text-[#c2c2c2] cursor-not-allowed'
                  "
                  :disabled="data.item.balance < 0"
                  @click="
                    data.item.balance >= 0 &&
                      renderActionList('transfer', data.item.status) &&
                      handleTransferWithAlert(data.item)
                  "
                >
                  <span class="k-convert-card  text-[16px]" />
                  <span class="text-[px]">Transfer Saldo</span>
                </button>
                <button
                  class="flex gap-1 mt-[8px] items-center"
                  :class="
                    renderActionList('detail', data.item.status) && data.item.balance >= 0
                      ? 'text-[#333333] cursor-pointer hover:bg-[#FFECE9]'
                      : 'text-[#c2c2c2] cursor-not-allowed'
                  "
                  :disabled="data.item.balance < 0"
                  @click="
                    data.item.balance >= 0 &&
                      renderActionList('detail', data.item.status) &&
                      handleDetail(data.item)
                  "
                >
                  <span class="k-card text-[16px]" />
                  <span class="text-[14px]">Detail </span>
                </button>
              </BPopover>
              <div
                class="flex justify-center w-full gap-[10px]"
                :class="windowWidth < 480 && 'd-none'"
              >
                <div
                  v-if="role !== 'TALENT GLOBAL'"
                  v-b-tooltip.hover
                  title="Topup Komcards"
                  :class="data.item.level === 'gold'
                    ? 'cursor-not-allowed bg-[#F8F8F8] text-[#c2c2c2]' :
                      renderActionList('topup', data.item.status)
                        ? 'text-[#333333] cursor-pointer hover:bg-[#FFECE9]'
                        : 'text-[#c2c2c2]'
                  "
                  class="bg-[#F8F8F8] rounded-[8px] p-[5px] justify-center items-center"
                  @click="data.item.level !== 'gold' && renderActionList('transfer', data.item.status) &&
                    handleTopup(data.item)"
                >
                  <span class="k-send-square text-[24px]" />
                </div>

                <div
                  v-b-tooltip.hover
                  :title="data.item.balance < 0 ? 'Saldo minus membatasi fitur kartu' : 'Transfer Saldo'"
                  class="bg-[#F8F8F8] rounded-[8px] p-[5px] flex justify-center items-center"
                  :class="
                    renderActionList('transfer', data.item.status) && data.item.balance >= 0
                      ? 'text-[#333333] cursor-pointer hover:bg-[#FFECE9]'
                      : 'text-[#c2c2c2] cursor-not-allowed'
                  "
                  @click="
                    data.item.balance >= 0 &&
                      renderActionList('transfer', data.item.status) &&
                      handleTransferWithAlert(data.item)
                  "
                >
                  <span class="k-convert-card text-[24px]" />
                </div>
                <div
                  v-b-tooltip.hover
                  :title="data.item.balance < 0 ? 'Saldo minus membatasi fitur kartu' : 'Detail'"
                  class="bg-[#F8F8F8] rounded-[8px] p-[5px] justify-center items-center"
                  :class="
                    renderActionList('detail', data.item.status) && data.item.balance >= 0
                      ? 'text-[#333333] cursor-pointer hover:bg-[#FFECE9]'
                      : 'text-[#c2c2c2] cursor-not-allowed'
                  "
                  @click="
                    data.item.balance >= 0 &&
                      renderActionList('detail', data.item.status) &&
                      handleDetail(data.item)
                  "
                >
                  <span class="k-card text-[24px]" />
                </div>
              </div>
            </template>
            <template #cell(status)="data">
              <span class="text-[#333333] flex text-[14px] text-nowrap gap-[4px] items-center">
                <div
                  class="h-[8px] w-[8px] rounded-full"
                  :class="colorStatus(data.item.status)"
                />
                <div>{{ statusCard(data.item.status) }}</div>
              </span>
            </template>
          </BTable>
          <!-- END : LIST -->
        </BOverlay>
      </div>
      <!-- END : CARD LIST  -->

      <div
        v-if="activeViewCard === 'grid'"
        class="flex d-flex justify-center gap-[5px] mb-[20px]"
      >
        <button
          :disabled="renderButtonNext || loading.card"
          :class="renderButtonNext && !loading.card && 'bg-[#F4F4F4]'"
          class="flex focus:ring-0 focus:outline-none focus:ring-offset-0 outline-none justify-center items-center h-[32px] w-[32px] border-[#E2E2E2] border-[1px] rounded-[6px]"
          @click="prevCarousel"
        >
          <img
            class="h-1/2"
            src="https://storage.googleapis.com/komerce/assets/illustration/arrow-left.svg"
            alt="left"
          >
        </button>
        <button
          :disabled="renderButtonNext || loading.card"
          :class="renderButtonNext && !loading.card && 'bg-[#F4F4F4]'"
          class="flex focus:ring-0 focus:ring-offset-0 focus:outline-none justify-center items-center h-[32px] w-[32px] border-[#E2E2E2] border-[1px] rounded-[6px]"
          @click="nextCarousel"
        >
          <img
            class="h-1/2"
            src="https://storage.googleapis.com/komerce/assets/illustration/arrow-right.svg"
            alt="left"
          >
        </button>
      </div>
      <BRow class="pl-[15px] pr-[15px] mt-[20px] lg:mt-[40px]  items-center justify-between">
        <div class="text-black font-semibold m-0 text-2xl">
          Mutasi
        </div>
        <div class="flex items-center flex-row">
          <BButton
            style="padding: 5px 1rem"
            variant="outline-primary"
            size="sm"
            @click="$bvModal.show('download-mutation-transaction-komcards')"
          >
            <div class="ml-[10px] mr-[10px] flex items-center">
              <b-img
                src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/document-download.svg"
              />
              <span class="ml-[4px]">Download Mutasi</span>
            </div>
          </BButton>
          <div class="ml-1">
            <BButton
              id="filter"
              size="sm"
              variant="primary"
            >
              <img
                src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/filter-search.svg"
                alt="Komerce"
                width="20"
              >
            </BButton>
            <BPopover
              target="filter"
              triggers="click"
              placement="bottomleft"
            >
              <label>Tanggal</label>
              <BRow>
                <BCol md="6">
                  <FlatPickr
                    v-model="startDate"
                    class="form-control"
                    placeholder="Mulai Dari"
                    :config="{
                      mode: 'single',
                      altInput: true,
                      altFormat: 'j/n/Y',
                      dateFormat: 'Y-m-d',
                    }"
                    @input="setStartDate"
                  />
                </BCol>
                <BCol md="6">
                  <FlatPickr
                    v-model="endDate"
                    class="form-control"
                    placeholder="Sampai Dengan"
                    :config="{
                      mode: 'single',
                      altInput: true,
                      altFormat: 'j/n/Y',
                      dateFormat: 'Y-m-d',
                      minDate: startDate,
                    }"
                    @input="setEndDate"
                  />
                </BCol>
              </BRow>
              <label class="mt-1">Jenis Transaksi</label>
              <VSelect
                v-model="transactionType"
                :options="optionsTransactionType"
                :reduce="option => option.value"
                label="name"
                @input="setTransactionType"
              >
                <span
                  slot="no-options"
                  @click="$refs.select.open = false"
                />
              </VSelect>
              <label class="mt-1">Nama Kartu</label>
              <VSelect
                v-model="cardId"
                :options="optionsCardId"
                :reduce="option => option.value"
                label="name"
              >
                <span
                  slot="no-options"
                  @click="$refs.select.open = false"
                />
              </VSelect>
              <BRow class="mx-auto mt-2">
                <BButton
                  variant="outline-primary"
                  class="mr-1"
                  @click.prevent="resetFilter()"
                >
                  Reset
                </BButton>
                <BButton
                  variant="primary"
                  @click.prevent="getListMutation()"
                >
                  Terapkan
                </BButton>
              </BRow>
            </BPopover>
          </div>
        </div>
      </BRow>
      <Mutation
        :scroll="'scroll'"
        :loading="loading.mutation"
        :items="listMutation"
        :fields="fields"
        :status-class="statusClass"
        :nominal-class="nominalClass"
      />
      <ModalCreatePin />
      <ModalInfoBalance
        :balance="balance"
        :min-saldo-kompay="minSaldoKompay"
      />
      <ModalTopup
        ref="modalTopup"
        :card-data="cardData"
        :balance="balanceData"
        @update-nominal-topup="updateNominalTopup"
      />
      <ModalDownloadMutasi :list-cards="allDataCard" />
      <ModalTransfer
        :id="idModalTransfer"
        ref="modalTransfer"
        :info-balance="balanceDetail"
        @update-payload-transfer="updatePayloadTransfer"
      />
      <ModalLimitQuota />
      <ModalGamification @refresh="getGamificationData" />

      <ModalPIN
        id="modal-verify-pin"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        title="Verifikasi PIN"
        description="Mohon verifikasi identitas kamu dengan masukan PIN"
        label-confirm-button="Konfirmasi"
        label-cancel-button="Kembali"
        @on-confirm-button="onSubmit"
        @on-cancel-button="onClose"
      />
    </BCard>

    <ModalMaxChancePIN />
    <ModalAccountSuspended
      ref="modalAccountSuspended"
      :visible="isSuspended"
    />
    <ModalNotificationTransaction
      :initial-notification-types="transactionNotificationConfig.notification_types"
      :initial-nominal="transactionNotificationConfig.nominal"
      :initial-auto-freeze="transactionNotificationConfig.auto_freeze"
      :loading="loadingConfirmTransaction"
      @confirm="onConfirmNotificationTransaction"
    />
    <ModalSetupNotification
      :notification-setup="declineNotificationData"
      @connected="getNotificationSetup"
    />
  </div>
</template>

<script>
import { FULL_DATE_TIME, YEAR_MONTH_DAY } from '@/libs/formatDate'
import { getUserData } from '@/auth/utils'
import size from 'lodash/size'
import moment from 'moment'
import { komshipAxiosIns, newAxiosIns } from '@/libs/axios'
import FlatPickr from 'vue-flatpickr-component'
import VSelect from 'vue-select'
import VueSlickCarousel from 'vue-slick-carousel'
import { IDR } from '@/libs/currency'
import useVerticalNavMenu from '@/@core/layouts/layout-vertical/components/vertical-nav-menu/useVerticalNavMenu'
import getAcronym from '@/libs/acronym'
import isEmpty from 'lodash/isEmpty'
import secureLs from '@/libs/secureLs'
import ModalPIN from '@/views/components/modal/ModalPIN.vue'
import ModalMaxChancePIN from '@/views/components/modal/ModalMaxChancePIN.vue'
import {
  columnConfig,
  settings,
  optionsTransactionType,
  listViewConfig,
  listViewConfigTeam,
} from './config'
import {
  Mutation,
  ModalCreatePin,
  ModalInfoBalance,
  ModalTransfer,
  ModalTopup,
  ModalDownloadMutasi,
  ModalGamification,
  Gamification,
  MasterCard,
  ModalAccountSuspended,
  ModalNotificationTransaction,
  ModalSetupNotification,
} from './components'
import ModalLimitQuota from './components/ModalLimitQuota.vue'
import '@/@core/scss/vue/libs/vue-flatpicker.scss'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import SpendingCategoryVue from './components/SpendingCategory.vue'
import HealthAccount from './components/HealthAccount.vue'

export default {
  components: {
    ModalLimitQuota,
    Mutation,
    Gamification,
    ModalInfoBalance,
    ModalTopup,
    ModalGamification,
    FlatPickr,
    VSelect,
    MasterCard,
    VueSlickCarousel,
    SpendingCategoryVue,
    ModalDownloadMutasi,
    ModalTransfer,
    ModalPIN,
    ModalMaxChancePIN,
    ModalCreatePin,
    HealthAccount,
    ModalAccountSuspended,
    ModalNotificationTransaction,
    ModalSetupNotification,
  },
  data() {
    return {
      helpdesk: process.env.VUE_APP_HELP_KOMCARDS_SCORE,
      IDR,
      FULL_DATE_TIME,
      YEAR_MONTH_DAY,
      isEmpty,

      // START : LIST VIEW
      activeViewCard: 'grid',

      // END : LIST VIEW

      notificationStatus: {
        decline_notification: 'inactive',
        transaction_notification: 'inactive',
      },
      declineNotificationData: null,
      transactionNotificationConfig: {
        notification_types: ['non_ads_merchant'],
        nominal: '',
        auto_freeze: false,
      },
      declineNotificationConfig: {
        channel: 'email',
        email: '',
        telegram: '',
        isVerified: false,
        status: 'inactive',
      },
      isDropdownOpen: false,
      loadingNotificationSetup: false,
      loadingNotificationTransSetup: false,
      loadingConfirmTransaction: false,
      loadingConfirmDecline: false,

      // START : carousel state
      stateCarousel: 0,
      firstRenderCards: true,
      initialSlide: 0,
      jumlahSlide: 3, // dynamic by viewport
      settings,
      windowWidth: 0,
      carouselKey: 0,
      onSearch: false,
      // END : carousel state

      // START : params data cards
      dataCard: [],
      isUnlimitedCard: null,
      limit_card: 10,
      offset_card: 0,
      search_card: null,
      status_card: null,
      // END : params data cards

      idModalTransfer: null,
      isActivePopover: false,
      scrollY: 0, // Track scroll position
      optionStatus: [
        {
          label: 'Semua Status',
          value: null,
        },
        {
          label: 'Aktif',
          value: 'active',
        },
        {
          label: 'Tidak Aktif',
          value: 'inactive',
        },
        {
          label: 'Pending',
          value: 'pending',
        },
        {
          label: 'Freeze',
          value: 'freeze',
        },
        {
          label: 'Cancelled',
          value: 'cancel',
        },
      ],
      status: null,
      fields: columnConfig,
      listMutation: [],
      showCardDetails: false,
      activeCard: null,
      balanceDetail: {},
      loading: {
        card: false,
        mutation: false,
        balanceDetailForTransfer: false,
        pin: false,
        balance: false,
        getBalanceMonit: false,
      },
      size,
      idPartner: this.$store.state.auth.userData.id,
      role: secureLs.getItem('userData').role_name.toUpperCase(),
      balance: null,
      startDate: moment()
        .startOf('month')
        .format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      limit: 10,
      offset: 0,
      lastData: false,
      totalCard: null,
      lastDataCard: false,
      transactionType: '',
      optionsTransactionType,
      cardId: '',
      optionsCardId: [],
      allDataCard: [],
      selectedTransactions: [],
      filtered_total: null,
      maxCard: 0,
      minCard: 4,
      maxCardMessage: '',
      minCardMessage:
        'Kamu telah membuat 5 kartu komcards. Biaya pembuatan kartu berikutnya adalah Rp. 25.000/kartu dengan saldo awal minimal Rp. 20.000. Periksa saldo kompaymu sebelum melanjutkan proses selanjutnya!',
      warningMessage: null,
      minTopUp: 45000,
      minSaldo: 20000,
      minSaldoKompay: null,
      cardData: {},
      showModalTopup: false,
      balanceData: null,
      profile: {},
      nextItem: false,
      score: null,

      // START : Gamification
      dataGamification: null,
      isActiveGamification: null,
      bannerGamification: 'active',
      spendingGamification: null,
      maxSpendingGamification: 400000000,
      stateForOpenPIN: '',
      topupAmount: null,
      transferAmount: null,
      cardTransferId: null,
      levelingGamification: [
        {
          title: 'Level 1',
          labelCurrentcy: 'Rp100Juta',
          valueMinimum: 100000000,
        },
        {
          title: 'Level 2',
          labelCurrentcy: 'Rp200Juta',
          valueMinimum: 200000000,
        },
        {
          title: 'Level 3',
          labelCurrentcy: 'Rp300Juta',
          valueMinimum: 300000000,
        },
        {
          title: 'Level 4',
          labelCurrentcy: 'Rp400Juta',
          valueMinimum: 400000000,
        },
      ],
      typeControl: 'komcard_score',
      parentData: null,
      // END
    }
  },
  setup(props) {
    const { isVerticalMenuCollapsed } = useVerticalNavMenu(props.item)

    return {
      isVerticalMenuCollapsed,
    }
  },
  computed: {
    isDeclineNotificationActive() {
      if (this.declineNotificationData && this.declineNotificationData.notification_status === 'active') return true
      if (!this.notificationStatus) return false
      return (
        this.notificationStatus.decline_notification === 'active'
        || this.notificationStatus.decline === true
        || this.notificationStatus.notification_status === 'active'
      )
    },
    isTransactionNotificationActive() {
      if (!this.notificationStatus) return false
      return (
        this.notificationStatus.transaction_notification === 'active'
        || this.notificationStatus.transaction === true
      )
    },
    activeNotificationCount() {
      let count = 0
      if (this.isDeclineNotificationActive) count += 1
      if (this.isTransactionNotificationActive) count += 1
      return count
    },
    isAnyNotificationActive() {
      return this.activeNotificationCount > 0
    },
    // LOGIC UNLIMITED CARD & DISABLED CREATE CARD
    // isAddCardDisabled akan bernilai true jika
    // 1. Type Control Akun komcards_score AND (isCheckKyc true OR isCanAddCard false)
    // 2. Type Control Akun manual AND (filtered_total >= maxCard OR filtered_total === maxCard AND !isUnlimitedCard)
    // 3. By Default check total (this.filtered_total) kartu harus sama dengan quota (this.maxCard) AND tidak unlimited card (!this.isUnlimitedCard)
    isAddCardDisabled() {
      return (
        (this.typeControl !== 'manual' && (this.isCheckKyc || !this.isCanAddCard))
        || (this.typeControl === 'manual' && this.filtered_total >= this.maxCard)
        || (this.filtered_total === this.maxCard && !this.isUnlimitedCard)
      )
    },
    isSuspended() {
      const { userData } = this.$store.state.auth
      return userData && parseInt(userData.status, 10) === 4
    },
    fieldsListView() {
      return this.role !== 'TALENT GLOBAL' ? listViewConfig : listViewConfigTeam
    },
    renderButtonNext() {
      if (this.windowWidth <= 480 && this.dataCard.length <= 1) {
        return true
      }

      if (this.windowWidth >= 481 && this.windowWidth <= 820 && this.dataCard.length <= 2) {
        return true
      }

      if (this.windowWidth >= 821 && this.dataCard.length <= 3) {
        return true
      }

      // return true means true for disable button
      return false
    },
    renderBannerGamification() {
      if (
        this.dataGamification.achieved_at === null
        && this.dataGamification.expired_at === null
      ) {
        return 'pending'
      }

      if (new Date().getTime() > new Date(this.dataGamification.expired_at).getTime()) {
        return 'expired'
      }

      if (new Date().getTime() < new Date(this.dataGamification.expired_at).getTime()) {
        return 'active'
      }

      return 'pending'
    },

    renderProgressGamification() {
      if (
        this.dataGamification.achieved_at === null
        && this.dataGamification.expired_at === null
      ) {
        return 'active'
      }

      return 'inactive'
    },
    setStartDate() {
      return value => {
        this.startDate = value
      }
    },
    setEndDate() {
      return value => {
        this.endDate = value
      }
    },
    setTransactionType() {
      return value => {
        this.transactionType = value
      }
    },
    statusClass() {
      return status => {
        if (status === 'success') {
          return 'text-[#34A770]'
        }
        if (status === 'failed') {
          return 'text-[#E31A1A]'
        }
        if (status === 'pending') {
          return 'text-[#828282]'
        }
        return ''
      }
    },
    nominalClass() {
      return type => {
        if (type === 'credit') {
          return 'text-[#34A770]'
        }
        if (type === 'debit') {
          return 'text-[#E31A1A]'
        }
        if (type === 'cashback') {
          return 'text-[#CC9212]'
        }
        return ''
      }
    },
    resetFilter() {
      return () => {
        this.startDate = moment()
          .startOf('month')
          .format('YYYY-MM-DD')
        this.endDate = moment().format('YYYY-MM-DD')
        this.transactionType = ''
        this.cardId = ''
      }
    },

    isCheckKyc() {
      if (this.dataCard.length >= 0) {
        if (
          this.profile.verification_ktp_status === 0
          || this.profile.verification_ktp_status === 1
          || this.profile.verification_ktp_status === 3
          || this.profile.verification_ktp_status === 4
        ) {
          return true
        }
      }
      return false
    },
    titleCheckKyc() {
      if (this.profile.verification_ktp_status === 0) {
        return 'Verifikasi KTP'
      }
      if (this.profile.verification_ktp_status === 1) {
        return 'Verifikasi KTP dalam proses persetujuan'
      }
      if (this.profile.verification_ktp_status === 3) {
        return 'Verifikasi KTP ditolak'
      }
      if (this.profile.verification_ktp_status === 4) {
        return 'Verifikasi KTP telah ditinjau ulang'
      }
      return null
    },
    messageCheckKyc() {
      if (this.profile.verification_ktp_status === 0) {
        return 'Kamu perlu verifikasi KTP untuk dapat membuat kartu Komcards dan menikmati fitur Komcards lainnya.'
      }
      if (this.profile.verification_ktp_status === 1) {
        return 'Maaf kamu belum bisa membuat kartu. Tunggu Verifikasi KTP hingga disetujui admin dengan estimasi 1x24 jam. Kamu bisa cek updatenya melalui email atau notifikasi lonceng.'
      }
      if (this.profile.verification_ktp_status === 3) {
        return 'Pengajuan verifikasi KTP ditolak, silahkan ajukan verifikasi ulang untuk bisa membuat kartu baru'
      }
      if (this.profile.verification_ktp_status === 4) {
        return 'Verifikasi KTP kamu ditolak oleh Bank. Mohon ajukan verifikasi ulang untuk melanjutkan pembuatan kartu baru'
      }
      return null
    },
    buttonKycBanner() {
      if (this.profile.verification_ktp_status === 0) {
        return 'Verifikasi Sekarang'
      }
      if (this.profile.verification_ktp_status === 3 || this.profile.verification_ktp_status === 4) {
        return 'Verifikasi Ulang'
      }
      return null
    },
    isCanAddCard() {
      const length = this.filtered_total || 0

      let currentScore = this.score
      if (this.parentData && this.parentData.nmp_score !== undefined && this.parentData.nmp_score !== null) {
        currentScore = this.parentData.nmp_score
      }

      if (currentScore >= 61 && currentScore <= 70) {
        return length < 5
      }

      if (currentScore >= 41 && currentScore <= 60) {
        return length < 1
      }

      if (currentScore >= 71) {
        return true
      }

      return false
    },
    isBannerScoring() {
      const length = this.filtered_total || 0

      if (this.score >= 38 && this.score <= 60 && length >= 1) {
        return {
          show: true,
          dismissible: true,
          showLinkHelpdesk: false,
          title: 'Mencapai Batas Pembuatan Kartu!',
          desc: 'Kamu sudah mencapai limit 1 kartu sesuai Komcards Skor saat ini. <span class="font-semibold">Tingkatkan skor ke 71+ untuk mendapatkan unlimited kartu.</span>',
        }
      }
      if (this.score >= 61 && this.score <= 70 && length >= 5) {
        return {
          show: true,
          dismissible: true,
          showLinkHelpdesk: false,
          title: 'Maksimal 5 Kartu sudah Tercapai',
          desc: 'Kamu sudah mencapai limit 5 kartu sesuai Komcards Skor saat ini. <span class="font-semibold">Tingkatkan skor ke 71+ untuk mendapatkan unlimited kartu.</span>',
        }
      }

      return {
        show: false,
        dismissible: false,
        showLinkHelpdesk: false,
        title: null,
        desc: null,
      }
    },
    isBannerLowScore() {
      if (this.score <= 38) {
        return {
          show: true,
          dismissible: false,
          showLinkHelpdesk: true,
          title: 'Tingkatkan Komcards Score Kamu!',
          desc: 'Segera tingkatkan Komcards Score Kamu untuk menghindari pembatasan akses Komcards!',
        }
      }

      if (this.score >= 39 && this.score <= 40) {
        return {
          show: true,
          dismissible: true,
          showLinkHelpdesk: false,
          title: 'Tingkatkan Komcards Score Kamu!',
          desc: 'Kamu tidak bisa mengakses Komcards jika Scoremu <span class="font-semibold">lebih rendah dari 39</span>',
        }
      }

      if (this.score >= 41 && this.score <= 45) {
        return {
          show: true,
          dismissible: true,
          showLinkHelpdesk: true,
          title: 'Tingkatkan Komcards Score Kamu!',
          desc: 'Segera tingkatkan Komcards Score Kamu untuk menghindari pembatasan akses Komcards!',
        }
      }

      return {
        show: false,
        dismissible: false,
        showLinkHelpdesk: false,
        title: null,
        desc: null,
      }
    },
  },
  watch: {
    scrollY: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.isActivePopover = false
          this.$root.$emit('bv::hide::popover')
        }
      },
    },
    status_card: {
      handler(newValue, oldValue) {
        this.stateCarousel = 0
        this.initialSlide = 0
        this.offset_card = 0
        this.carouselKey = 0
        this.lastDataCard = false
        this.firstRenderCards = true

        this.getListCard()
      },
    },
    dataCard: {
      handler(newValue, oldValue) {
        const arrayOfIdNew = newValue.map(e => e.id)
        const arrayOfIdOld = oldValue.map(e => e.id)

        const resultfilter = arrayOfIdNew.filter(
          item => !arrayOfIdOld.includes(item),
        )

        // handle jika user langsung ke kartu terakhir
        const resultfilterNull = newValue
          .filter(e => e.balance === undefined || e.balance === null)
          .map(e => e.id)
        if (this.dataCard.length > 0) {
          if (
            newValue.map(e => e.id).sort() !== oldValue.map(e => e.id).sort()
            && newValue.length > 0
            && resultfilterNull.length > 0
          ) {
            const combinedUnique = [
              ...new Set([...resultfilter, ...resultfilterNull]),
            ]

            this.getBalanceMonit(combinedUnique)
          }
          this.forceRerender()
        }
      },
      deep: true,
    },
    stateCarousel(newValue, oldValue) {
      // if previous state = 0 (first render) and current state = 1 (next state)
      if (
        newValue + 1 === this.dataCard.length
        && this.dataCard.length >= this.limit_card
        && this.filtered_total > this.limit_card
      ) {
        this.getNextDataCards('last')
        this.lastDataCard = true
      }

      if (newValue + this.jumlahSlide === this.dataCard.length && newValue > oldValue && this.filtered_total > this.limit_card) {
        this.getNextDataCards('next')
      }
    },
  },
  created() {
    window.onscroll = () => {
      if (
        window.innerHeight + window.scrollY
          >= document.getElementById('scroll').offsetHeight
        && !this.loading.mutation
      ) {
        this.getNextDataMutation()
      }
    }
  },
  mounted() {
    this.activeViewCard = this.$store.state.komcards.viewList
    this.windowWidth = window.innerWidth
    // Optionally, add a resize event listener for dynamic updates
    window.addEventListener('resize', this.handleResize)

    window.addEventListener('scroll', this.handleScrollBody)
    document.addEventListener('click', this.handleClickOutsideNotification)
    this.checkUnlimitedCard()
    this.getListCard()
    this.getListMutation()
    this.getProfile()
    this.getAllDataCard()
    this.getGamificationData()
    this.fetchNotificationSetup()
    this.getTypeAccount()
    this.getNotificationSetup()
    this.getNotificationTransactionSetup()
    this.getScore()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('scroll', this.handleScrollBody) // Clean up event listener
    document.removeEventListener('click', this.handleClickOutsideNotification)
  },
  methods: {
    toggleDropdownNotification() {
      this.isDropdownOpen = !this.isDropdownOpen
    },
    closeDropdownNotification() {
      this.isDropdownOpen = false
    },
    handleClickOutsideNotification(event) {
      if (
        this.isDropdownOpen
        && this.$refs.dropdownNotification
        && !this.$refs.dropdownNotification.contains(event.target)
      ) {
        this.closeDropdownNotification()
      }
    },
    handleDeclineNotification() {
      this.closeDropdownNotification()
      this.loadingConfirmDecline = false
      this.getNotificationSetup()
      this.$bvModal.show('modal-setup-notification')
    },
    fetchNotificationSetup() {
      return this.getNotificationSetup()
    },
    applyNotificationSetup(data) {
      if (!data) return
      this.declineNotificationData = data
      const channel = (data.notification_channel || 'email').toLowerCase()
      const isActive = data.notification_status === 'active'
      const isTelegram = channel === 'telegram'
      const isEmail = channel === 'email'

      this.declineNotificationConfig = {
        channel: isTelegram ? 'telegram' : 'email',
        email: isEmail ? (data.notification_receiver || '') : '',
        telegram: isTelegram ? (data.notification_receiver || '') : '',
        isVerified: isActive,
        status: data.notification_status,
      }

      if (!this.notificationStatus) {
        this.notificationStatus = {}
      }
      this.$set(
        this.notificationStatus,
        'decline_notification',
        isActive ? 'active' : 'inactive',
      )
    },
    async getNotificationSetup() {
      this.loadingNotificationSetup = true
      try {
        const res = await newAxiosIns.get('/komcards/api/v1/notification_setup')
        const data = res?.data?.data
        if (data) {
          this.applyNotificationSetup(data)
        }
      } catch (error) {
        if (error?.response?.status === 404) {
          try {
            const fallbackRes = await newAxiosIns.get('/api/v1/notification_setup')
            const fallbackData = fallbackRes?.data?.data
            if (fallbackData) {
              this.applyNotificationSetup(fallbackData)
            }
          } catch (e) {
            // ignore fallback error
          }
        }
      } finally {
        this.loadingNotificationSetup = false
      }
    },
    async onConfirmNotificationDecline(payload) {
      const channel = (payload.channel || 'email').toLowerCase()
      const receiver = channel === 'email'
        ? (payload.email || payload.value || '').trim()
        : (payload.telegram || payload.receiver || this.declineNotificationConfig.telegram || '').trim()

      const postPayload = {
        notification_channel: channel,
        notification_receiver: receiver,
      }

      this.loadingConfirmDecline = true
      try {
        let res
        try {
          res = await newAxiosIns.post('/komcards/api/v1/notification_setup', postPayload)
        } catch (error) {
          if (error?.response?.status === 404) {
            res = await newAxiosIns.post('/api/v1/notification_setup', postPayload)
          } else {
            throw error
          }
        }

        this.declineNotificationConfig = {
          ...payload,
          channel,
          email: channel === 'email' ? receiver : this.declineNotificationConfig.email,
          telegram: channel === 'telegram' ? receiver : this.declineNotificationConfig.telegram,
          isVerified: channel === 'email' ? payload.isVerified : true,
          status: 'active',
        }

        if (!this.notificationStatus) {
          this.notificationStatus = {}
        }
        this.$set(this.notificationStatus, 'decline_notification', 'active')
        const channelLabel = channel === 'email' ? 'Email' : 'Telegram'
        this.$toast_success({ message: res?.data?.meta?.message || `Notifikasi decline berhasil dihubungkan ke ${channelLabel}` })
        this.$bvModal.hide('modal-notification-decline')
      } catch (err) {
        const errorMsg = err?.response?.data?.message || err?.response?.data?.meta?.message || 'Gagal menghubungkan notifikasi decline'
        this.$toast_error({ message: errorMsg })
      } finally {
        this.loadingConfirmDecline = false
      }
    },
    handleTransactionNotification() {
      this.closeDropdownNotification()
      this.loadingConfirmTransaction = false
      this.getNotificationTransactionSetup()
      this.$bvModal.show('modal-notification-transaction')
    },
    applyNotificationTransactionSetup(data) {
      if (!data) return
      const notificationTypes = []
      if (data.notif_by_nominal) {
        notificationTypes.push('nominal')
      }
      if (data.notif_by_non_ads_merchant) {
        notificationTypes.push('non_ads_merchant')
      }

      if (notificationTypes.length === 0) {
        notificationTypes.push('non_ads_merchant')
      }

      let formattedNominal = ''
      if (
        data.notif_by_nominal_amount !== undefined
        && data.notif_by_nominal_amount !== null
        && data.notif_by_nominal_amount !== ''
      ) {
        const num = Number(String(data.notif_by_nominal_amount).replace(/\D/g, ''))
        if (num > 0) {
          formattedNominal = new Intl.NumberFormat('id-ID').format(num)
        }
      }

      this.transactionNotificationConfig = {
        notification_types: notificationTypes,
        nominal: formattedNominal,
        auto_freeze: !!data.trigger_auto_freeze,
        raw: { ...data },
      }

      const isTransActive = Boolean(
        data.notif_by_nominal || data.notif_by_non_ads_merchant,
      )

      if (!this.notificationStatus) {
        this.notificationStatus = {}
      }
      this.$set(
        this.notificationStatus,
        'transaction_notification',
        isTransActive ? 'active' : 'inactive',
      )
    },
    async getNotificationTransactionSetup() {
      this.loadingNotificationTransSetup = true
      try {
        const res = await newAxiosIns.get('/komcards/api/v1/notification_transaction_setup')
        const data = res?.data?.data
        if (data) {
          this.applyNotificationTransactionSetup(data)
        }
      } catch (error) {
        if (error?.response?.status === 404) {
          try {
            const fallbackRes = await newAxiosIns.get('/api/v1/notification_transaction_setup')
            const fallbackData = fallbackRes?.data?.data
            if (fallbackData) {
              this.applyNotificationTransactionSetup(fallbackData)
            }
          } catch (e) {
            // ignore fallback error
          }
        }
      } finally {
        this.loadingNotificationTransSetup = false
      }
    },
    async onConfirmNotificationTransaction(payload) {
      const hasNominal = Boolean(payload.notif_by_nominal)
      const hasNonAds = Boolean(payload.notif_by_non_ads_merchant)
      const isTransActive = hasNominal || hasNonAds

      const postPayload = {
        notif_by_nominal: hasNominal,
        notif_by_nominal_amount: hasNominal ? Number(payload.notif_by_nominal_amount || 0) : 0,
        notif_by_non_ads_merchant: hasNonAds,
        trigger_auto_freeze: isTransActive ? Boolean(payload.trigger_auto_freeze) : false,
      }

      this.loadingConfirmTransaction = true
      try {
        let res
        try {
          res = await newAxiosIns.post('/komcards/api/v1/notification_transaction_setup', postPayload)
        } catch (error) {
          if (error?.response?.status === 404) {
            res = await newAxiosIns.post('/api/v1/notification_transaction_setup', postPayload)
          } else {
            throw error
          }
        }

        this.transactionNotificationConfig = {
          ...payload,
          notification_types: payload.notification_types || [],
          nominal: payload.nominal,
          auto_freeze: postPayload.trigger_auto_freeze,
        }

        if (!this.notificationStatus) {
          this.notificationStatus = {}
        }
        this.$set(this.notificationStatus, 'transaction_notification', isTransActive ? 'active' : 'inactive')
        this.$toast_success({ message: res?.data?.meta?.message || 'Pengaturan notifikasi berhasil disimpan' })
        this.$bvModal.hide('modal-notification-transaction')
      } catch (err) {
        const errorMsg = err?.response?.data?.message || err?.response?.data?.meta?.message || 'Gagal menyimpan pengaturan notifikasi transaksi'
        this.$toast_error({ message: errorMsg })
      } finally {
        this.loadingConfirmTransaction = false
      }
    },
    statusCard(value) {
      const data = {
        active: 'Aktif',
        inactive: 'Tidak Aktif',
        pending: 'Pending',
        freeze: 'Dibekukan',
        cancel: 'Dibatalkan',
      }

      return data[value]
    },
    colorStatus(value) {
      const data = {
        active: 'bg-[#34A770]',
        inactive: 'bg-[#E31A1A]',
        pending: 'bg-[#c2c2c2]',
        freeze: 'bg-[#828282]',
        cancel: 'bg-[#828282]',
      }

      return data[value]
    },
    getAvatarData(value) {
      return getAcronym(value)
    },
    handleScrollBody() {
      this.scrollY = window.scrollY || document.documentElement.scrollTop // Get scroll position from window
    },
    handleClickPopoverOnTable(id) {
      this.$root.$emit('bv::hide::popover')
      this.$root.$emit('bv::show::popover', id)
    },
    renderListView(data) {
      if (this.windowWidth < 480) {
        return data.filter(e => e.key !== 'balance')
      }

      return data
    },
    renderActionList(action, status) {
      this.$root.$emit('bv::hide::popover')

      if (action === 'topup') {
        if (status === 'active') {
          return true
        }

        if (status === 'inactive') {
          return false
        }

        if (status === 'pending') {
          return false
        }
        if (status === 'freeze') {
          return false
        }
        if (status === 'cancel') {
          return false
        }
      } else if (action === 'transfer') {
        if (status === 'active') {
          return true
        }

        if (status === 'inactive') {
          return false
        }

        if (status === 'pending') {
          return false
        }
        if (status === 'freeze') {
          return false
        }
        if (status === 'cancel') {
          return false
        }
      } else {
        if (status === 'active') {
          return true
        }

        if (status === 'inactive') {
          return true
        }

        if (status === 'pending') {
          return false
        }
        if (status === 'freeze') {
          return true
        }
        if (status === 'cancel') {
          return true
        }
      }
      return false
    },
    // START: Method card change (transfer, Topup, Detail)
    handleDetail(card) {
      if (card.status === 'pending') {
        return null
      }
      if (card.balance < 0) {
        this.$toast_error({ message: 'Saldo minus membatasi fitur kartu. Lakukan Top Up untuk memulihkan akses' })
        return null
      }
      return this.$router.push(`/komcards/${card.id}`)
    },
    handleTopup(card) {
      if (card.level === 'bronze') return
      if (card.status === 'pending' || card.status === 'inactive') {
        if (card.status === 'inactive') {
          this.$toast_error({ message: 'Kartu anda tidak aktif, silahkan aktifkan terlebih dahulu' })
        }
        return
      }

      this.cardData = card
      this.stateForOpenPIN = 'topup'
      this.checkVerifyPIN('topup')
      this.getBalance()
    },
    handleTransfer(id) {
      this.balanceDetailForTransfer(id)
      this.idModalTransfer = parseInt(id, 10)
      this.stateForOpenPIN = 'transfer'
      this.checkVerifyPIN('transfer')
    },
    handleTransferWithAlert(card) {
      if (card.status === 'pending' || card.status === 'inactive') {
        if (card.status === 'inactive') {
          this.$toast_error({
            message:
              'Kartu anda tidak aktif, silahkan aktifkan terlebih dahulu',
          })
        }

        return
      }
      this.handleTransfer(card.id)
    },
    // END: Method card change (transfer, Topup, Detail)

    // START : GAMIFICATION
    handleClaimGamification() {
      this.$bvModal.show('modal-gamification')
    },
    async getGamificationData() {
      const url = '/auth/api/v1/komcard/gamification'

      try {
        const res = await newAxiosIns.request({
          method: 'GET',
          url,
        })

        const { spending } = res.data.data
        this.spendingGamification = spending

        this.dataGamification = res.data.data
        this.isActiveGamification = true
      } catch (error) {
        this.isActiveGamification = false
      }
    },
    // END : GAMIFICATION

    // START : CAROUSEL AND PAGINATION
    async getAllDataCard() {
      const url = '/komcards/api/v1/card/list?levels=bronze,platinum,gold'

      const params = {
        offset: 0,
        // limit is 10000 this get all data
        limit: 10000,
      }

      try {
        const res = await newAxiosIns.get(url, { params })
        this.allDataCard = res.data.data

        const debitCard = [
          {
            value: '',
            name: 'Semua',
          },
          ...this.allDataCard.map(card => ({
            value: card.id,
            name: card.name,
          })),
        ]

        this.$nextTick(() => {
          this.optionsCardId = debitCard
        })
        return
      } catch (error) {
        this.$toast_error({
          message: 'Gagal load data card',
        })
      }
    },
    async getScore() {
      const url = '/komcards/api/v1/user/nmp/score'
      try {
        const { data } = await newAxiosIns.get(url)
        this.score = data.data.score
      } catch {
        this.$toast_error({ message: 'Gagal mendapatkan data skor' })
      }
    },
    getNextDataCards(state) {
      let param
      if (this.firstRenderCards) {
        param = this.limit_card
      } else {
        param = 0
      }
      if (!this.lastDataCard) {
        let limit = this.limit_card
        let offset = this.offset_card + param

        if (state === 'last') {
          limit = this.totalCard
          offset = 0
        }

        this.loading.card = true
        const params = {
          search: this.search_card,
          offset,
          limit,
          status: this.status_card,
        }

        const url = '/komcards/api/v1/card/list'

        newAxiosIns
          .get(url, { params })
          .then(res => {
            const { data, meta } = res.data
            const newArrayData = data.map(obj => ({
              ...obj,
              balance: undefined,
            }))

            this.filtered_total = meta.filtered_total

            if (state === 'last') {
              this.dataCard = [...newArrayData]
            } else {
              this.dataCard = [...this.dataCard, ...newArrayData]
            }

            this.offset_card = data.length + this.offset_card + param

            if (data.length < this.limit_card) {
              this.lastDataCard = true
            }

            this.initialSlide = state === 'next' ? this.stateCarousel : this.filtered_total - 1
            this.firstRenderCards = false

            this.loading.card = false
          })
          .catch(e => {
            this.loading.card = false
            this.$toast_error({
              message: 'Gagal load data card',
            })
          })
      }
    },
    handleScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target
      this.isActivePopover = false
      if (scrollTop + clientHeight >= scrollHeight - 1) {
        this.getNextDataCards('next')
      }
    },

    nextCarousel() {
      this.$refs.carousel.next()
    },
    prevCarousel() {
      this.$refs.carousel.prev()
    },
    handleResize() {
      this.windowWidth = window.innerWidth
    },
    forceRerender() {
      this.carouselKey += 1
    },
    handleEnterSearch(e) {
      if (e.key === 'Enter' || e.keyCode === 13) {
        this.onSearch = true
        this.stateCarousel = 0
        this.initialSlide = 0
        this.offset_card = 0

        if (this.search_card && this.search_card !== '') {
          this.getListSearch()
          this.lastDataCard = true
        } else {
          this.lastDataCard = false
          this.getListCard()
        }
      } else {
        this.onSearch = false
      }
    },
    handleBeforeChange(e) {
      this.stateCarousel = e
    },

    // END : CAROUSEL AND PAGINATION

    resetSearch() {
      this.search_card = null
      this.lastDataCard = false
      this.initialSlide = 0
      this.getListCard()
    },

    changeView(view) {
      this.carouselKey = 0
      this.stateCarousel = 0
      this.$store.commit('komcards/UPDATE_VIEW_LIST', view)
      this.activeViewCard = view
    },
    async getListSearch() {
      this.loading.card = true

      const params = {
        search: this.search_card,
        offset: 0,
        limit: this.totalCard, // totalCard,
        status: this.status_card,
      }
      const url = '/komcards/api/v1/card/list'
      await newAxiosIns
        .request({ url, method: 'get', params })
        .then(res => {
          const { data, meta } = res.data

          this.maxCard = meta.quota
          this.totalCard = meta.total
          this.filtered_total = meta.filtered_total

          const newArrayData = data.map(obj => ({ ...obj, balance: undefined }))

          this.maxCardMessage = `Batas maksimal Kartu Komcards yang bisa kamu buat adalah ${this.maxCard} kartu dan kamu telah mencapai batas maksimum untuk pembuatan Kartu Komcards.`
          this.$nextTick(() => {
            this.dataCard = newArrayData
          })

          this.loading.card = false
        })
        .catch(() => {
          this.loading.card = false
          this.$toast_error({
            message: 'Gagal memuat data kartu, silahkan coba lagi',
          })
        })
    },
    async checkUnlimitedCard() {
      // check unlimited card availibity
      const urlCheckUnlimited = '/komcards/api/v1/card/check-unlimited-quota'

      const availibity = await newAxiosIns.get(urlCheckUnlimited)

      this.isUnlimitedCard = availibity.data.data.status
    },
    async getListCard() {
      this.loading.card = true

      const params = {
        search: this.search_card,
        offset: this.offset_card,
        limit: this.limit_card,
        status: this.status_card,
      }
      const url = '/komcards/api/v1/card/list'
      await newAxiosIns
        .request({ url, method: 'get', params })
        .then(res => {
          const { data, meta } = res.data

          this.maxCard = meta.quota
          this.totalCard = meta.total
          this.filtered_total = meta.filtered_total

          this.maxCardMessage = `Batas maksimal Kartu Komcards yang bisa kamu buat adalah ${this.maxCard} kartu dan kamu telah mencapai batas maksimum untuk pembuatan Kartu Komcards.`
          const newArrayData = data.map(obj => ({ ...obj, balance: undefined }))
          this.dataCard = newArrayData

          if (this.totalCard > this.minCard && this.totalCard < this.maxCard) {
            this.warningMessage = this.minCardMessage
          }
          this.loading.card = false
        })
        .catch(() => {
          this.loading.card = false
          this.$toast_error({
            message: 'Gagal memuat data kartu, silahkan coba lagi',
          })
        })
    },
    async getBalanceMonit(arrayOfIdCard) {
      this.loading.getBalanceMonit = true
      const url = '/komcards/api/v1/card/balance-cards'
      try {
        const res = await newAxiosIns.request({
          method: 'post',
          data: {
            card_ids: arrayOfIdCard,
          },
          url,
        })

        const { data } = res.data

        for (let i = 0; i < data.length; i += 1) {
          for (let j = 0; j < this.dataCard.length; j += 1) {
            if (data[i].id === this.dataCard[j].id) {
              this.dataCard[j].balance = data[i].balance
            }
          }
        }

        this.loading.getBalance = false
        this.loading.getBalanceMonit = false
      } catch (error) {
        this.loading.getBalance = false
        this.loading.getBalanceMonit = false
        this.$toast_error({
          message: 'Gagal load data get balance',
        })
      }
    },
    async getListMutation() {
      this.loading.mutation = true
      this.offset = 0
      const params = {
        start_date: this.startDate,
        end_date: this.endDate,
        transaction_type: this.transactionType,
        card_id: this.cardId,
        offset: this.offset,
        limit: this.limit,
      }
      const url = '/komcards/api/v1/card/mutation'
      await newAxiosIns
        .get(url, { params })
        .then(res => {
          const { data } = res.data
          this.listMutation = data
          this.loading.mutation = false

          this.offset = data.length
          if (data.length < this.limit) {
            this.lastData = true
          } else {
            this.lastData = false
          }
        })
        .catch(() => {
          this.loading.mutation = false
          this.$toast_error({
            message: 'Gagal load data balance, silahkan coba lagi',
          })
        })
    },
    async checkVerifyPIN(param) {
      await newAxiosIns.get('/auth/api/v1/user/secured/verify-pin/attempt-left')
        .then(response => {
          const { data } = response.data
          if (data.attempt_left === 0) {
            this.$bvModal.show('max-chance-PIN')
          } else if (param === 'transfer') {
            this.$bvModal.show('modal-transfer')
          } else if (param === 'topup') {
            this.$bvModal.show('modal-topup')
          } else if (param === 'create') {
            this.$router.push({
              path: '/komcards/add',
              query: { count: this.totalCard },
            })
          }
        }).catch(() => {
          this.$toast_error({ message: 'Gagal cek PIN, silahkan refresh page' })
        })
    },
    async checkPin(event) {
      if (this.typeControl === 'manual' && event === 'button-add') {
        this.$router.push({
          path: '/komcards/add',
          query: { count: this.totalCard },
        })
        return
      }

      if (!this.isUnlimitedCard && this.totalCard >= this.maxCard) {
        this.loading.pin = false
        this.$bvModal.show('modal-limit-quota')
        return
      }

      if (event === 'button-add') {
        const url = '/v1/pin/check'
        await komshipAxiosIns
          .get(url)
          .then(res => {
            this.loading.pin = false
            const {
              data: { is_set },
            } = res.data

            // eslint-disable-next-line camelcase
            if (is_set === false) {
              this.$bvModal.show('modal-check-pin')
            } else {
              this.checkBalance()
            }
          })
          .catch(() => {
            this.loading.pin = false
            this.$toast_error({ message: 'Gagal check pin, silahkan coba lagi' })
          })
      }
    },

    async balanceDetailForTransfer(id) {
      this.loading.balanceDetailForTransfer = true

      const url = `/komcards/api/v1/card/${id}/info-balance`

      await newAxiosIns
        .get(url)
        .then(res => {
          const { data } = res.data
          this.loading.balanceDetailForTransfer = false
          const balanceDetail = { ...data, balance: data.real_balance }
          this.balanceDetail = balanceDetail
        })
        .catch(() => {
          this.loading.balanceDetailForTransfer = false
          this.$toast_error({
            message: 'Gagal memuat data balance, silahkan coba lagi',
          })
        })
    },
    async checkBalance() {
      this.loading.balance = true
      const url = 'komship/api/v1/dashboard/partner/balanceSummary'
      await newAxiosIns
        .get(url)
        .then(res => {
          const {
            data: { balance },
          } = res.data
          this.balance = balance
          this.loading.balance = false
          if (balance < this.minSaldo && this.dataCard.length < 5) {
            this.$bvModal.show('modal-info-balance')
            this.minSaldoKompay = this.minSaldo
          } else if (balance < this.minTopUp && this.dataCard.length >= 5) {
            this.$bvModal.show('modal-info-balance')
            this.minSaldoKompay = this.minTopUp
          } else {
            this.stateForOpenPIN = 'create'
            this.checkVerifyPIN('create')
          }
        })
        .catch(() => {
          this.loading.balance = false
          this.$toast_error({
            message: 'Gagal load data balance, silahkan coba lagi',
          })
        })
    },
    async getBalance() {
      const url = 'api/v1/dashboard/partner/balanceSummary'
      await newAxiosIns
        .get(url)
        .then(res => {
          const { data: { balance } } = res.data
          this.balanceData = balance
        })
        .catch(() => {
          this.$toast_error({
            message: 'Gagal load data balance, silahkan coba lagi',
          })
        })
    },
    async getProfile() {
      const url = '/v1/my-profile'
      await komshipAxiosIns.post(url).then(res => {
        const { data } = res.data
        this.profile = data
      })
    },
    getNextDataMutation() {
      if (!this.lastData) {
        this.loading.mutation = true
        const params = {
          start_date: this.startDate,
          end_date: this.endDate,
          transaction_type: this.transactionType,
          card_id: this.cardId,
          offset: this.offset,
          limit: this.limit,
        }
        const url = '/komcards/api/v1/card/mutation'
        newAxiosIns
          .get(url, { params })
          .then(res => {
            const { data } = res.data
            this.loading.mutation = false
            this.$nextTick(() => {
              this.listMutation.push(...data)
            })
            this.offset += data.length
            if (data.length < this.limit) {
              this.lastData = true
            }
          })
          .catch(() => {
            this.loading.mutation = false
            this.$toast_error({
              message: 'Gagal load data balance, silahkan coba lagi',
            })
          })
      }
    },
    onSubmit(value) {
      if (this.stateForOpenPIN === 'transfer') {
        this.onTransfer(value)
      } else if (this.stateForOpenPIN === 'topup') {
        this.onTopup(value)
      }
    },
    onClose() {
      this.$bvModal.hide('modal-verify-pin')
      if (this.stateForOpenPIN === 'transfer') {
        this.$bvModal.show('modal-transfer')
        this.transferAmount = null
        this.cardTransferId = null
      } else if (this.stateForOpenPIN === 'topup') {
        this.$bvModal.show('modal-topup')
        this.topupAmount = null
      }
    },
    async onTopup(pin) {
      const payload = {
        card_id: this.cardData.id,
        balance: Number(this.topupAmount.replace(/[^0-9]/g, '')),
        pin,
      }
      const url = '/komcards/api/v1/card/topup'
      await newAxiosIns.post(url, payload)
        .then(() => {
          const message = 'Top up berhasil di lakukan'
          this.$toast_success({ message })
          this.$bvModal.hide('modal-verify-pin')
          this.$bvModal.hide('modal-topup')
          this.getListMutation()
          this.topupAmount = null
        })
        .catch(err => {
          const { message } = err.response.data
          if (message === 'insufficient kompay balance') {
            this.$toast_error({ message: 'Saldo anda tidak mencukupi' })
          } else if (message === 'card has been freeze') {
            this.$toast_error({ message: 'Kartu terkena autofreeze oleh sistem. Silahkan hubungi CS kami.' })
          } else if (message === 'pending transaction found, cannot proceed') {
            this.$toast_error({ message: 'Maaf, top up belum dapat dilakukan karena masih terdapat transaksi sebelumnya yang belum selesai. Silakan coba beberapa saat lagi.' })
          } else {
            this.$toast_error({ message: 'Terjadi kesalahan ketika topup, mohon hubungi team cs kami untuk lebih lanjut' })
          }
        })
        .finally(() => {
          this.$refs.modalTopup.onReset()
        })
    },
    async onTransfer(pin) {
      const url = `/komcards/api/v1/card/${this.idModalTransfer}/transfer-balance`
      const payload = {
        pin,
        transfer_to: this.cardTransferId,
        amount: Number(this.transferAmount.replace(/[Rp. ]/g, '')),
      }
      await newAxiosIns.post(url, payload)
        .then(() => {
          this.$toast_success({ message: 'Saldo berhasil ditransfer' })
          this.transferAmount = null
          this.cardTransferId = null
        })
        .catch(err => {
          const { message } = err.response.data.meta
          if (message === 'pending transaction found, cannot proceed') {
            this.$toast_error({ message: 'Transaksi sedang diproses. Mohon tunggu beberapa saat' })
          } else if (message === 'card has been freeze') {
            this.$toast_error({ message: 'Kartu terkena autofreeze oleh sistem. Silahkan hubungi CS kami.' })
          } else if (message === 'insufficient kompay balance') {
            this.$toast_error({ message: 'Transaksi tidak dapat diproses. Silakan periksa saldo Kompay Anda.' })
          } else {
            this.$toast_error({ message: 'Terjadi kesalahan sementara. Mohon coba lagi dalam beberapa saat' })
          }
        })
        .finally(() => {
          this.$refs.modalTransfer.onReset()
        })
    },
    async getTypeAccount() {
      const url = '/komcards/api/v1/user/control-account'
      await newAxiosIns.get(url)
        .then(({ data }) => {
          const dataAccount = data.data
          this.typeControl = dataAccount.type_control
          this.parentData = dataAccount.parent_user
        })
        .catch(() => {
          this.$toast_error({ message: 'Terjadi kesalahan sementara. Mohon coba lagi dalam beberapa saat' })
        })
    },
    updatePayloadTransfer(value) {
      this.transferAmount = value.amount
      this.cardTransferId = value.cardTransferId
    },
    updateNominalTopup(value) {
      this.topupAmount = value
    },
  },
}
</script>

<style lang="scss" scoped src="./Komcard.scss" />

<style>
.popover-warning-balance.popover {
  background-color: #333333 !important;
  border: none !important;
  border-radius: 8px !important;
  max-width: 280px;
}

.popover-warning-balance.popover .popover-body {
  color: #ffffff !important;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.5;
  padding: 8px 12px !important;
}

.popover-warning-balance.popover .arrow::before {
  border-top-color: #333333 !important;
}

.popover-warning-balance.popover .arrow::after {
  border-top-color: #333333 !important;
}

/* Komcard Notification Dropdown */
.komcard-notif-wrapper {
  position: relative;
  display: inline-block;
}

.btn-notif-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 42px;
  padding: 0 16px;
  background-color: #ffffff;
  border: 1.5px solid #f95031;
  border-radius: 12px;
  cursor: pointer;
  outline: none;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  user-select: none;
  box-sizing: border-box;
}

.btn-notif-trigger:hover {
  background-color: #fff6f4;
  border-color: #f95031;
}

.btn-notif-trigger:active,
.btn-notif-trigger.is-active {
  background-color: #fff0eb;
  border-color: #f95031;
  box-shadow: 0 0 0 3px rgba(249, 80, 49, 0.15);
}

.notif-trigger-icon {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  display: block;
}

.notif-trigger-text {
  margin-left: 8px;
  margin-right: 12px;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #f95031;
  line-height: 1;
  white-space: nowrap;
}

/* Status Dot */
.notif-status-dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  flex-shrink: 0;
  display: inline-block;
  transition: background-color 0.2s ease;
}

.notif-status-dot.status-inactive {
  background-color: #bdbdbd;
}

.notif-status-dot.status-active {
  background-color: #27ae60;
}

/* Dropdown Menu */
.komcard-notif-menu {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  z-index: 1050;
  width: 250px;
  padding: 6px;
  background-color: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 12px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  transform-origin: top left;
}

/* Dropdown Items */
.notif-menu-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  padding: 0 10px;
  margin-bottom: 2px;
  border-radius: 6px;
  cursor: pointer;
  user-select: none;
  background-color: transparent;
  transition: background-color 0.18s cubic-bezier(0.16, 1, 0.3, 1);
}

.notif-menu-item:last-child {
  margin-bottom: 0;
}

.notif-menu-item:hover {
  background-color: #ffe8d9;
}

.notif-menu-item:hover .notif-item-chevron {
  transform: translateX(2px);
}

.notif-item-title {
  font-family: 'Poppins', sans-serif;
  font-size: 15px;
  font-weight: 400;
  color: #000000;
  line-height: 1;
  white-space: nowrap;
}

.notif-item-meta {
  display: flex;
  align-items: center;
  gap: 10px;
}

.notif-item-chevron {
  color: #000000;
  stroke-width: 2;
  transition: transform 0.18s ease;
}

/* Native CSS Transitions */
.notif-dropdown-enter-active {
  transition: opacity 0.22s cubic-bezier(0.16, 1, 0.3, 1),
              transform 0.22s cubic-bezier(0.16, 1, 0.3, 1);
}

.notif-dropdown-leave-active {
  transition: opacity 0.18s cubic-bezier(0.16, 1, 0.3, 1),
              transform 0.18s cubic-bezier(0.16, 1, 0.3, 1);
}

.notif-dropdown-enter {
  opacity: 0;
  transform: translateY(-8px) scale(0.96);
}

.notif-dropdown-enter-to {
  opacity: 1;
  transform: translateY(0) scale(1);
}

.notif-dropdown-leave {
  opacity: 1;
  transform: translateY(0) scale(1);
}

.notif-dropdown-leave-to {
  opacity: 0;
  transform: translateY(-6px) scale(0.97);
}
</style>
